import {Badge as MantineBadge, BadgeProps as MantineBadgeProps} from "@mantine/core";
import {forwardRef} from "react";

export type BadgeProps = MantineBadgeProps & {
  // extend props here
}

export const Badge = forwardRef<HTMLDivElement, BadgeProps>((props, ref) => {
  const {...rest} = props;

  return <MantineBadge ref={ref} {...rest} />;
});
